export default [
  {
    path: '/lotto-balance-report',
    name: 'lotto-balance-report',
    component: () => import('@/views/lottoBalanceReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.lottoBalanceReport',
      resource: 'balance-report-lotto',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listLottoBalanceReport',
          active: true,
        },
      ],
    },
  },
]
